import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { debounce } from 'underscore';
import { useEditable } from 'use-editable';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { BrandliveEvent, IHomepageMainNavItems, IHomepageProfileNavItems, NavMainItems, NavProfileItems } from '../../../../../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../../../../../general-ui/icon';
import { mainNavIcons, profileNavIcons } from '../../../post-register-preview';
import { PATHNAMES } from "../../../../../admin";
import classNames from 'classnames';

interface ISortableSessionNavItem {
	id: string;
	navItem: IHomepageMainNavItems | IHomepageProfileNavItems;
	handleNavItemClick?: any;
	handleViewerClick: any;
	handleUpdateTitle: any;
	workingEvent: BrandliveEvent;
	className?: string;
	notSortable?: boolean;
	notEditable?: boolean;
}

const SortableSessionNavItem = (props: ISortableSessionNavItem): JSX.Element => {
	const {
		navItem,
		handleNavItemClick,
		// handleViewerClick,
		handleUpdateTitle,
		workingEvent,
		className = "",
		notSortable = false,
		notEditable = false,
	} = props;

	const [navName, setNavName] = useState(navItem?.custom_name?.base || navItem.name);
	const [initialized, setInitialized] = useState(false);
	const [active, setActive] = useState(false);

	const editNavNameRef = useRef<HTMLDivElement | null>(null);

	const debounced = useRef(debounce((value: string, cb: (value: string) => void) => {
		cb(value);
	}, 300)).current;

	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
	} = useSortable({ id: props.id });

	useEffect(() => {
		if (!initialized && navItem) {
			setInitialized(true);
			setNavName(navItem?.custom_name?.base || navItem.name);
		}
	}, [navItem, initialized]);


	const style = {
		transform: CSS.Transform.toString(transform),
		transition: 'none',
	};


	function handleFocus() {
		setActive(true);
	}
	async function handleBlur() {
		setActive(false);
		setNavName(navName);

		debounced(navName, async debouncedVal => {
			handleUpdateTitle(debouncedVal, navItem);
		});
	}

	const icon = mainNavIcons(navItem.name as NavMainItems) || profileNavIcons(navItem.name as NavProfileItems);



	const handleNameChange = (value: string) => {
		setNavName(value);
	};
	useEditable(editNavNameRef, handleNameChange);

	const navPath = navItem.name !== NavMainItems.Session
		? PATHNAMES.Event[navItem.name](workingEvent?.uuid)
		: PATHNAMES.Session.SessionLink(workingEvent?.uuid, workingEvent?.sessions[0].uuid, workingEvent?.sessions[0].default_language);

	const editable = (
		<div
			className={classNames("editable-nav-name", { active })}
			ref={editNavNameRef}
			onFocus={handleFocus}
			onBlur={handleBlur}
		>
			{navName}
		</div>
	);

	return (
		<div ref={notSortable ? null : setNodeRef} style={style} className={classNames("main-nav-item radius-main", className, { dragging: attributes["aria-pressed"] })}>
			{notSortable ? (<></>) : (
				<div className="drag-handle" {...attributes} {...listeners}>
					<Icon name={ICONS.DRAG_HANDLE} size={12} color={COLORS.GRAY} />
				</div>
			)}
			<div>
				{icon ? (
					<div className="main-nav-item-icon-container">
						<Icon name={icon} size={16} color={COLORS.WHITE} />
					</div>
				) : null}
			</div>

			{
				notEditable
					? (
						<div className="editable-nav-name">
							{navName}
						</div>
					)
					: editable
			}

			<div className="main-nav-icon-view">
				{/* FUTUREDEV hiding this "hide" feauture for till we get more page types implimented, will probably still need to block for "home" */}
				{/* optional render is inside this div for spacing purposes */}
				{/* {!isJustLink && (
					<button className="no-style clear" onClick={() => handleViewerClick(navItem)}>
						<Icon name={navItem?.is_on ? ICONS.VIEWERS_EYE : ICONS.VIEWERS_EYE_OFF} color={COLORS.GRAY} size={16} />
					</button>
				)} */}
			</div>
			<div className="main-nav-item-go">
				<Link role="button" to={navPath} onClick={handleNavItemClick && handleNavItemClick(navItem.name)} className="clear no-style">
					<Icon name={ICONS.ARROW_RIGHT} size={16} color={COLORS.WHITE} />
				</Link>
			</div>
		</div >
	);
};

export default SortableSessionNavItem;